import { z } from 'zod';
import UIStrings from '@/Utils/UIStrings';

export const accountCreationMaxLength = 128;

const accountCreationRequiredString = z
    .string()
    .min(1, UIStrings.Required)
    .max(accountCreationMaxLength, UIStrings.MaxSymbolsValidationError(accountCreationMaxLength));

export const accountCreationSchema = z.object({
    firstName: accountCreationRequiredString,
    lastName: accountCreationRequiredString,
    companyName: accountCreationRequiredString,
});

export type AccountCreationFormValues = z.infer<typeof accountCreationSchema>;

export const defaultAccountCreationFormValues: AccountCreationFormValues = {
    firstName: '',
    lastName: '',
    companyName: '',
};

export const accountCreationFieldNames: { [key in keyof AccountCreationFormValues]: key } = {
    firstName: 'firstName',
    lastName: 'lastName',
    companyName: 'companyName',
};
